export const ADDRESS_HANDLER_KEYS = {
  ADDRESS: 'address',
  DA_DATA: 'daData',
  IS_DA_DATA: 'isDaData',
  POSTAL_CODE: 'postalCode',
};

export const ISSUER_HANDLER_KEYS = {
  CODE: 'code',
  NAME: 'name',
};
